import Query from '/node_modules/cogent-js/src/Query'
import { resolveStatusIds, viewSupportsStatusFilter } from 'constants/ticketStatus.constant'

// Constructor único de la query del Inbox. Reemplaza a `setQuery` y
// `buildViewQuery` de TicketInboxList y a la copia local que vivía dentro del
// empty state de TicketTableContent. Los tres armaban el mismo switch y había que
// mantenerlos sincronizados a mano.
//
// `new Query()` en cada llamada y no una instancia compartida: cogent-js acumula
// los `where` sobre la instancia, así que reusarla arrastra los filtros de la
// llamada anterior.
//
// Sobre el orden: si el usuario eligió uno en la barra, manda ese. Si no, manda el
// propio de la vista, que hoy solo tiene "Menciones". Ese `-last_mention` es la
// razón de ser de la vista: con el `-id` que trae el backend por default, un
// hallazgo viejo donde me acaban de nombrar cae al fondo.
const VIEW_DEFAULT_SORT = {
	mentioned: '-last_mention',
}

export const buildInboxQuery = ({
	view,
	userId,
	storeSelected,
	parentCategorySelected,
	categorySelected,
	statusGroups,
	sort,
} = {}) => {
	const query = new Query().for('tickets')

	storeSelected && query.where('store_id', storeSelected)
	parentCategorySelected && query.where('ticket_category.parent_id', parentCategorySelected)
	categorySelected?.length > 0 && query.whereIn('ticket_category_id', categorySelected)

	// Las vistas por usuario solo agregan su `where` si hay id. El estado inicial del
	// store se arma antes de que exista la sesión, y cogent-js tira
	// "The where() function takes 2 arguments both of string values" si el valor es
	// undefined. Sin id la query queda sin el filtro de usuario, igual que el string
	// literal que había antes acá; el efecto de la lista la rearma con el id ya cargado.
	switch (view) {
		case 'owner':
			userId && query.where('owner_id', userId)
			break
		case 'operator':
			userId && query.where('operator_id', userId)
			break
		case 'mentioned':
			query.where('mentioned_me', true)
			break
		case 'favorite':
			query.where('favorite', true)
			break
		case 'all':
		case 'stores':
		default:
			break
	}

	// Solo las vistas con eje de estado lo mandan. "Menciones" y "Favorito" no
	// llevan filtro aunque haya un valor guardado en el store para otra vista.
	if (viewSupportsStatusFilter(view)) {
		const statusIds = resolveStatusIds(statusGroups)
		statusIds && query.whereIn('ticket_status_id', statusIds)
	}

	const userSort = sort?.field
		? (sort.order === 'asc' ? sort.field : `-${sort.field}`)
		: null
	const appliedSort = userSort || VIEW_DEFAULT_SORT[view]

	appliedSort && query.params({ sort: appliedSort })

	return query.url()
}

export default buildInboxQuery
